import { Box, Divider, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';

export const OrderDetails = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 0,
}));

export const ProductList = styled('ul')(() => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
}));

export const ProductListItem = styled('li')(() => ({
  display: 'block',
}));

export const LineItemRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const DiscountText = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
  textAlign: 'right',
  paddingTop: theme.spacing(2),
}));

export const OrderDisclaimer = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.text.primary,
}));

export function Title(props: { children: ReactNode; id?: string }) {
  return (
    <Typography variant="body1" sx={{ fontWeight: 600 }} id={props.id}>
      {props.children}
    </Typography>
  );
}

export function SectionDivider() {
  return <Divider sx={{ my: 3 }} />;
}
